module.exports = __webpack_public_path__ + "media/אבטיח.b703876f.mp3";